import { useState, useCallback, useEffect, useRef } from "react";
import "./OnDemandVideo.scss";
import AuthService from 'services/auth.service';
import ShareScreenOnIcon from "assets/icons/video-icons/share-screen-on.svg";
import ShareScreenOffIcon from "assets/icons/video-icons/share-screen-off.svg";
import AudioOffIcon from "assets/icons/video-icons/audio-off.svg";
import AudioOnIcon from "assets/icons/video-icons/audio-on.svg";
import CameraOnIcon from "assets/icons/video-icons/camera-on.svg";
import CameraOffIcon from "assets/icons/video-icons/camera-off.svg";
import MuteIcon from "assets/icons/video-icons/white-mute-icon.svg";
import TimerIcon from "assets/icons/video-icons/timer-outline-icon.svg";
import OnDemandService from "services/on-demand.service";
import Spinner from 'react-bootstrap/Spinner';
import ZoomVideo, { ConnectionState, ReconnectReason } from "@zoom/videosdk";
import CloseVideoCallConfirmationModal from "./CloseVideoCallConfirmationModal";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { ondemandSelector, setTerminateSession } from "app/ondemandSlice";
import ChatSessionService from "services/chat-session.service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// need to change to due to zoomvideo already been defined by videosdk
export function OnDemandVideo() {
  const [loading, setLoading] = useState(false);
  const zmClientRef = useRef(null);
  if (!zmClientRef.current) {
    zmClientRef.current = ZoomVideo.createClient();
  }
  const zmClient = zmClientRef.current;
  const joining = useRef(false);
  const [videoStarted, setVideoStarted] = useState(true);
  const [zoomSession, setZoomSession] = useState();
  const [isMuted, setIsMuted] = useState(false);
  const [audioStarted, setAudioStarted] = useState(false);
  const [sessionEnded, setSessionEnded] = useState(null);
  const [onDemand, setOnDemand] = useState(null);
  const [token, setToken] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [userMute, setUserMute] = useState(false);
  const [showEndSessionModal, setShowEndSessionModal] = useState(false);
  const [loadingEndSession, setLoadingEndSession] = useState(false);
  const [loadingCloseSession, setLoadingCloseSession] = useState(false);
  const [remainingTime, setRemainingTime] = useState(null);
  const [remainingTimeLabel, setRemainingTimeLabel] = useState('');
  const [isSharingScreen, setIsSharingScreen] = useState(false);
  const [hasEndedButOngoing, setHasEndedButOngoing] = useState(false);
  const dispatch = useDispatch();
  const isCancelled = useRef(false);
  const attachedParticipants = useRef(new Set());
  const { terminateSession } = useSelector(ondemandSelector);

  const search = window.location.search;
  const urlParams = new URLSearchParams(search);

  useEffect(() => {
    setLoading(true);
    if(urlParams && urlParams.get('on_demand_id')){
      OnDemandService.getDetails({
        id: urlParams.get('on_demand_id')
      }).then(
        (data) => {
        if(data.doctor?.id !== AuthService.getCurrentUser()?.id){
          setSessionEnded('Invalid Session');
        }else{
          setOnDemand(data);
          var current_time = moment().unix();
          var endTime = moment.unix(data?.video_session?.end_time)
          var duration = moment.duration(endTime.diff(moment.unix(current_time)));
          var getMinutes = duration.asMinutes();
          setRemainingTime(duration);
          if(getMinutes <= 0){
            setSessionEnded('Session Ended');
          }else{
            var status = data?.status;
            switch(status) {
              case 'ongoing':
                if(data?.video_session){
                  setToken(data.video_session.token)
                }
                break;
              case 'ended':
                setSessionEnded('Session Ended');
                break;
              default:
                setSessionEnded('Invalid Session');
            }
          }

          if(data?.status === 'ongoing'){
            setHasEndedButOngoing(true)
          }
         }
          setLoading(false);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      );
    }else{
      setSessionEnded('Invalid Session');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if(token){
      initial();
    }
  }, [token]);

  useEffect(() => {
    return () => {
      ZoomVideo.destroyClient();
      zmClientRef.current = null;
    };
  }, []);

  useEffect(() => {
    if(zoomSession){
      zoomSession.startVideo().then(() => {
        const currentUser = zmClient.getCurrentUserInfo();
        if(currentUser?.userId){
          return zoomSession.attachVideo(currentUser.userId, 1920).then((userVideo) => {
            document.querySelector('video-player-container').appendChild(userVideo);
          })
        }
      }).catch((err) => {
        console.log("Error starting video", err);
        setVideoStarted(false);
        toast("Unable to access your camera. Please check your camera connection and permissions.", {
          progressStyle: { background: '#FF725E' }
        });
      }).finally(() => {
        startAudioButton();
      });
    }
  }, [zoomSession]); // eslint-disable-line

  useEffect(() => {
    participants.forEach(function(p) {
      if (zmClient != null && zmClient.getCurrentUserInfo() != null){
        if(p.userId !== zmClient.getCurrentUserInfo().userId){
          attachParticipantVideo(zoomSession, p.userId);
          setUserMute(p?.muted);
        }
      }
    });
  }, [participants]); // eslint-disable-line

  useEffect(() => {
    var timer;
    if (remainingTime === null){
      setRemainingTimeLabel(null)
    }
    else if (remainingTime > 0) {
      timer = setTimeout(() => {
        var current_time = moment().unix();
        var endTime = moment.unix(onDemand?.video_session?.end_time)
        var duration = moment.duration(endTime.diff(moment.unix(current_time)));
        setRemainingTime(duration);
        var days = duration.asDays();
        var hours = duration.asHours() % 24;
        var minutes = duration.asMinutes() % 60;
        var seconds = duration.asSeconds() % 60;
        minutes = Math.floor(minutes);
        seconds = Math.floor(seconds);

        let lbl = (minutes > 9 ? minutes : "0" + minutes) + " : " + (seconds > 9 ? seconds : "0" + seconds);

        if(lbl === '01 : 00'){
          toast("This session ends in 1 minute.",{
            progressStyle: { background: '#FF725E' } // Change to your desired color
          });
        }
        setRemainingTimeLabel(lbl);
      }, 1000);
    } else {
      setRemainingTimeLabel("Session Ended");
    }

    return () => {
      clearTimeout(timer);
    };
  }, [remainingTime]);

  useEffect(() => {
    return () => {
      isCancelled.current = true;
    };
  }, [dispatch]); // eslint-disable-line

  useEffect(() => {
    if(terminateSession){
      setTerminateSession({status: false});
      handleTerminateSession();
    }
    return () => {
      isCancelled.current = true;
    };
  }, [terminateSession]); // eslint-disable-line

  const attachParticipantVideo = useCallback((stream, userId) => {
    if (!stream || attachedParticipants.current.has(userId)) return;
    attachedParticipants.current.add(userId);
    stream.attachVideo(userId, 1920).then((userVideo) => {
      document.querySelector('#participant-videos-canvas').appendChild(userVideo);
    }).catch((err) => {
      attachedParticipants.current.delete(userId);
      console.log("Error attaching participant video", err);
    });
  }, []);

  const detachParticipantVideo = useCallback((stream, userId) => {
    if (!stream || !attachedParticipants.current.has(userId)) return;
    attachedParticipants.current.delete(userId);
    stream.detachVideo(userId).then((elements) => {
      (Array.isArray(elements) ? elements : [elements]).forEach((e) => e?.remove());
    }).catch((err) => {
      console.log("Error detaching participant video", err);
    });
  }, []);

  const zmNotifyUser = () => {
    const params = {
      user_id: onDemand.user.id,
      teleconsult_on_demand_id: onDemand.id
    };
    ChatSessionService.notifyUser(params).then(
      (data) => {},
      (error) => {}
    );
  };

  const leaveSession = useCallback(async () => {
    try {
      // ending the session for everyone is a host-only privilege
      await zmClient.leave(zmClient.isHost());
    } catch (err) {
      console.log("Error leaving session", err);
    }
  }, [zmClient]);

  const startAudioButton = useCallback(async () => {
    try {
      if (audioStarted) {
        if (isMuted) {
          await zoomSession.unmuteAudio();
          setIsMuted(false);
        } else {
          await zoomSession.muteAudio();
          setIsMuted(true);
        }
      } else {
        await zoomSession.startAudio();
        setAudioStarted(true);
      }
    } catch (err) {
      console.log("Error - ", err);
      toast("Unable to access your microphone. Please check your microphone connection and permissions.", {
        progressStyle: { background: '#FF725E' }
      });
    }
  });

  const initial = async () => {
    if (joining.current) return;
    joining.current = true;

    await zmClient.init("en-US", "Global");

    try {
      await zmClient.join(onDemand?.video_session?.name, await token, onDemand?.doctor?.name);
      const stream = zmClient.getMediaStream();
      setZoomSession(stream);

      let participants = zmClient.getAllUser();
      setParticipants(participants)

      zmClient.on('user-added', (payload) => {
        setParticipants(zmClient.getAllUser())
      })

      zmClient.on('user-updated', (payload) => {
        if(payload?.userId !== zmClient.getCurrentUserInfo()?.userId){
          setUserMute(payload?.muted)
        }
      })

      zmClient.on('passively-stop-share', (payload) => {
        setIsSharingScreen(false);
      })      

      zmClient.on('command-channel-message', (payload) => {
        if (payload.senderName === zmClient.getCurrentUserInfo()?.displayName && payload.text === "host_end_all"){
          leaveSession();
        }
      })

      zmClient.on('peer-video-state-change', (payload) => {
        if (payload.action === 'Start') {
          // a user turned on their video, render it
          attachParticipantVideo(stream, payload.userId);
        } else if (payload.action === 'Stop') {
          // a user turned off their video, stop rendering it
          detachParticipantVideo(stream, payload.userId);
        }
      })
    } catch (err) {
      if(err?.errorCode === 200){
        setSessionEnded(err?.reason);
      }
      console.log("Error Joining Meeting", err);
    } finally {
      joining.current = false;
    }
  };

  const startVideoButton = useCallback(async () => {
    try {
      if (videoStarted) {
        await zoomSession.stopVideo();
        const currentUser = zmClient.getCurrentUserInfo();
        if(currentUser?.userId){
          zoomSession.detachVideo(currentUser.userId)
        }
        setVideoStarted(false);
      } else {
        await zoomSession.startVideo();
        const currentUser = zmClient.getCurrentUserInfo();
        if(currentUser?.userId){
          const userVideo = await zoomSession.attachVideo(currentUser.userId, 1920);
          document.querySelector('video-player-container').appendChild(userVideo)
        }
        setVideoStarted(true);
      }
    } catch (err) {
      console.log("Error - ", err);
      toast("Unable to access your camera. Please check your camera connection and permissions.", {
        progressStyle: { background: '#FF725E' }
      });
    }
  });

  
  const endCall = useCallback(async () => {
    setLoadingEndSession(true);
    if(zoomSession){
      await leaveSession();
    }
    OnDemandService.end({
      id: onDemand?.id
    }).then(
      (data) => {
        setLoadingEndSession(false);
        setHasEndedButOngoing(false);
        setShowEndSessionModal(false);
        setSessionEnded(data?.status === 'Success' ? 'SESSION ENDED' : 'You have left the call');
      },
      (error) => {
        setLoadingEndSession(false);
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        } else {
          setHasEndedButOngoing(false);
          setShowEndSessionModal(false);
          setSessionEnded("You have left the call");
        }
      }
    );
  });

  const closeCall = useCallback(async () => {
    setLoadingCloseSession(true);
    if(zoomSession){
      await leaveSession();
    }
    setLoadingCloseSession(false);
    setShowEndSessionModal(false);
    setSessionEnded("You have left the call");
  });

  const shareScreenButton = useCallback(async () => {
    try {
      if(isSharingScreen){
        zoomSession.stopShareScreen();
      }else{
        if (zoomSession.isStartShareScreenWithVideoElement()) {
          await zoomSession.startShareScreen(
            document.querySelector('#my-screen-share-content-video')
          )
          // screen share successfully started and rendered
        } else {
          await zoomSession.startShareScreen(
            document.querySelector('#my-screen-share-content-canvas')
          )
          // screen share successfully started and rendered
        }
      }
      setIsSharingScreen(!isSharingScreen)
    } catch (err) {
      console.log("Error - ", err);
    }
  });

  const sessionTimeExpired = remainingTime !== null && !(remainingTime > 0);
  const canRejoin = hasEndedButOngoing && !sessionTimeExpired;

  const backToTeleconsult = () => {
    localStorage.setItem('teleconsult:on-demand-session-ended', Date.now().toString());
    window.close();
  };

  const continueSession = () => {
    if(onDemand?.video_session){
      var current_time = moment().unix();
      var endTime = moment.unix(onDemand?.video_session?.end_time)
      var duration = moment.duration(endTime.diff(moment.unix(current_time)));
      if (duration > 0){
        zmNotifyUser();
        setSessionEnded(null)
        setToken(onDemand?.video_session.token)
        setLoadingCloseSession(false);

        if (onDemand?.video_session.token != null){
          initial();
        }
      }else{
        setHasEndedButOngoing(false);
        setSessionEnded('Session Time Expired');
      }
    }
  };

  const SessionEndContainer = () => {
    return (
      <div className="session-end">
          <div className="font-weight-bold">{sessionEnded}</div>
          {canRejoin && (
            <div>
              <div>
                <button className="btn session-option-rejoin-btn" onClick={() => continueSession()}>Rejoin Call</button>
                <button className="btn session-option-btn" onClick={() => backToTeleconsult()}>Back to Teleconsult</button>
              </div>
            </div>
          )}
          {sessionEnded === "Session Time Expired" && (
            <div>
              <div>Your session has ended as the allocated time has expired.</div>
              <br />
              <div>Fell free to schedule another session in necessary</div>
              <div>
                <button className="btn session-option-btn" onClick={() => backToTeleconsult()}>Back to Teleconsult</button>
              </div>
            </div>
          )}
          {!canRejoin && (sessionEnded === "SESSION ENDED" || sessionEnded === "You have left the call") && (
            <div>
              <button className="btn session-option-btn" onClick={() => backToTeleconsult()}>Back to Teleconsult</button>
            </div>
          )}
        </div>
    );
  };

  const handleTerminateSession = useCallback(async () => {
    if(zoomSession){
      await leaveSession();
    }
    setShowEndSessionModal(false);
    setHasEndedButOngoing(false);
    setSessionEnded('Session Time Expired');
  });

  return (
    <div className="zoom-video-page">
      { loading ? (
        <div className="loader">
          <Spinner animation="border" className="spinner" />
        </div>
      ) : sessionEnded ? <SessionEndContainer/> : (
        <>
          {remainingTimeLabel && <div className="countdown-timer"><img src={TimerIcon} alt="timer-icon"/>{remainingTimeLabel}</div>}
          <ToastContainer/>
          <video-player-container>
            <div className="user-identity">{(!audioStarted || isMuted) && <img src={MuteIcon} alt="mute-icon"/>} {onDemand?.doctor?.name}</div>
          </video-player-container>
          <div className="canvas-container">
            <div id="participant-videos-canvas"></div>
            <div className="user-identity">{userMute && <img src={MuteIcon} alt="mute-icon"/>} {onDemand?.user?.name}</div>
          </div>
          <video id="my-screen-share-content-video"></video>
          <canvas id="my-screen-share-content-canvas"></canvas>
          <div className="video-bar">
            <div className="session-name">{onDemand?.video_session?.name}</div>
            {zoomSession && (
              <div className="options-container">
                <button className="btn" onClick={() => startVideoButton()}><img src={videoStarted ? CameraOnIcon : CameraOffIcon} alt="camera-icon" /></button>
                <button className="btn" onClick={() => startAudioButton()}><img src={isMuted ? AudioOffIcon : AudioOnIcon} alt="audio-icon" /></button>
              </div>
            )}
            <button className="btn end-session-btn" onClick={() => setShowEndSessionModal(true)}>End Call</button>
          </div>
        </>
      )}
      <CloseVideoCallConfirmationModal show={showEndSessionModal} setShowEndSessionModal={setShowEndSessionModal} loadingEndSession={loadingEndSession} endCall={endCall} loadingCloseSession={loadingCloseSession} closeCall={closeCall} sessionTimeExpired={sessionTimeExpired} />
    </div>
  );
}

export default OnDemandVideo;
